import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Interfaces
import { ICategories } from '@interfaces/category.interface';

// Helpers
import { RoleHelper } from '@helpers/role.helper';

// Constants
import { USER_TYPE_URL } from '@constants/user-type-url.constants';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private httpClient = inject(HttpClient);

  getCategories(): Observable<ICategories> {
    return this.httpClient.get<ICategories>(
      `${RoleHelper.isTemporary() ? USER_TYPE_URL.TEMPORARY : USER_TYPE_URL.USER}get-services`,
    );
  }
}
